import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import {
  blogHeading,
  blogsSlidesData,
  categoryLabels,
} from "../../data/blogsData";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BlogSection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const selectedCategory = queryParams.get("category");

  const handleCategoryClick = (category) => {
    queryParams.set("category", category);
    navigate(`?${queryParams.toString()}`);
  };

  const { t } = useTranslation("blogs"); // ✅ Set correct namespace

  const blogsSlides = t("blogsSlideData", { returnObjects: true });
  const blogsHeadings = t("blogsHeadings", { returnObjects: true });

  console.log("blogs =>", blogsSlides);

  const filteredBlogs =
    !selectedCategory || selectedCategory === "all"
      ? blogsSlides
      : blogsSlides.filter((blog) => blog.category === selectedCategory);

  return (
    <>
      <div className="trends-insights blog-section-main">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h1 className="main-heading">{blogsHeadings.heading}</h1>
              <h3 className="sub-heading">{blogsHeadings.subHeading}</h3>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-xl-3 col-lg-3 col-md-12">
              <ul className="blog-sidebar-box">
                <li
                  className={
                    !selectedCategory || selectedCategory === "all"
                      ? "active-category"
                      : ""
                  }
                  onClick={() => handleCategoryClick("all")}
                  style={{ cursor: "pointer" }}
                >
                  {t("categoryLabels.all")}
                </li>
                {[
                  "web-developmet",
                  "ai-developmet",
                  "custom-developmet",
                  "mobile-app-developmet",
                  "devops-services",
                  "quality-assurance-services",
                  "data-analytics",
                  "blockchain-development",
                  "cyber-security",
                ].map((key, index) => (
                  <li
                    key={index}
                    className={
                      key === selectedCategory ? "active-category" : ""
                    }
                    onClick={() => handleCategoryClick(key)}
                    style={{ cursor: "pointer" }}
                  >
                    {t(`categoryLabels.${key}`)}
                  </li>
                ))}
              </ul>
            </div>

            {/* Blogs Listing */}
            <div className="col-xl-9 col-lg-9 col-md-12">
              <div className="container p-0">
                <div className="row">
                  {filteredBlogs?.map((card, index) => (
                    <div className="col-md-6 mb-4" key={index}>
                      <Link
                        to={`/blogs/${card.slug
                          .toLowerCase()
                          .replace(/[^a-z0-9\s-]/g, "")
                          .trim()
                          .replace(/\s+/g, "-")}`}
                        // className="common-green-btn details-btn"
                        style={{ textDecoration: 'none' }}
                      >
                        <div className="project-card-main">
                          <div className="project-image">
                            <img src={card?.imageSrc} alt={card?.title} />
                          </div>
                          <h2>{card?.title}</h2>
                          <p className="common-text blog-main-card-text mt-2">
                            {card?.description?.split(" ").slice(0, 15).join(" ")}
                            ...
                          </p>
                          {/* <div className="project-button">
                          <Link
                            to={`/blogs/${card.slug
                              .toLowerCase()
                              .replace(/[^a-z0-9\s-]/g, "")
                              .trim()
                              .replace(/\s+/g, "-")}`}
                            className="common-green-btn details-btn"
                          >
                            {blogsHeadings.seeDetails}{" "}
                            <i
                              className={`fa-solid ${document.dir === "rtl"
                                ? "fa-arrow-left"
                                : "fa-arrow-right"
                                }`}
                            ></i>
                          </Link>
                        </div> */}
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogSection;
